/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-classes-per-file */
import { takeEvery, select, spawn, take } from 'redux-saga/effects';
import {
  tracking as trackingActions,
  router as routerActions,
  viewer as viewerActions,
} from 'flux/actions';
import { ui as uiSelectors, router as routerSelectors } from 'flux/selectors';
import { GclidNonEUModel, GclidEUModel } from './models';
import { trackGclid } from './trackGclid';

function* _sendGclid(profilingConsent) {
  // wait for the user to open a PDF flyer
  yield take(viewerActions.types.INITIALIZE);

  yield spawn(trackGclid, profilingConsent);
}

class GclidNonEu extends GclidNonEUModel {
  *send(profilingConsent) {
    yield _sendGclid(profilingConsent);
  }
}

class GclidEu extends GclidEUModel {
  *send(profilingConsent) {
    yield _sendGclid(profilingConsent);
  }
}

const EU_WHITELIST = [
  'it_it',
  'fr_fr',
  'es_es',
  'de_at',
  'nl_be',
  'bg_bg',
  'cs_cz',
  'da_dk',
  'fi_fi',
  'de_de',
  'el_gr',
  'hu_hu',
  'nl_nl',
  'pl_pl',
  'pt_pt',
  'ro_ro',
  'sk_sk',
  'sv_se',
];

let _model;
const getGlid = (language) => {
  if (!_model) {
    _model = EU_WHITELIST.includes(language.toLowerCase()) ? new GclidEu() : new GclidNonEu();
  }

  return _model;
};

function* handleGclid(methodName, profilingConsent) {
  const location = yield select(routerSelectors.selectRouterLocation);
  const { gclid } = location.query || {};
  if (!gclid) return;

  const language = yield select(uiSelectors.selectLanguage);
  if (!language) return;

  const model = getGlid(language);
  yield model[methodName](profilingConsent);
}

export function* onProfileConsentInit({ payload: { profilingConsent } }) {
  const gclidDependenciesReady = yield select(routerSelectors.selectGclidDependenciesReady);
  // if gclidDependenciesReady is not set, wait for SET_GCLID_DEPENDENCIES_READY because trackingActions.trackSplunk needs them
  if (!gclidDependenciesReady) {
    yield take(routerActions.types.SET_GCLID_DEPENDENCIES_READY);
  }

  yield spawn(handleGclid, 'handleInit', profilingConsent);
}

export function* onProfileConsentUpdate({ payload: { profilingConsent } }) {
  yield spawn(handleGclid, 'handleConsentChanged', profilingConsent);
}

export default function* () {
  yield takeEvery(trackingActions.types.PROFILE_CONSENT_INIT, onProfileConsentInit);
  yield takeEvery(trackingActions.types.PROFILE_CONSENT_UPDATE, onProfileConsentUpdate);
}
